import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Personalities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personalidades: [],
      user: JSON.parse(localStorage.getItem('tpuser'))
    };
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_URL + '/type', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);

        this.setState({ personalidades: data });
      });
  }

  render() {
    const sex = this.state.user && this.state.user.sex == 'female' ? 'F' : 'M';

    const pink = this.state.personalidades.filter((p) => p.color == 'pink');
    const blue = this.state.personalidades.filter((p) => p.color == 'blue');
    const yellow = this.state.personalidades.filter((p) => p.color == 'yellow');
    const green = this.state.personalidades.filter((p) => p.color == 'green');

    let personalidad_blue = blue.map((p) => {
      return (
        <div className="col-md-3 col-xs-12 margin-top-30 text-center">
          <img
            src={'img-tipos/' + p.code + '_' + sex + 'small.svg'}
            className="margin-bot--60 img-80"
          />
          <div className="padding-caja b-caja">
            <hr />
            <h5 className="title">{p.name}</h5>
            <h4>{p.code}</h4>
            <Link
              to={'bars/' + p.code + '/descripcion'}
              className="btn btn-black">
              Leer más
            </Link>
          </div>
        </div>
      );
    });
    let personalidad_yellow = yellow.map((p) => {
      return (
        <div className="col-md-3 col-xs-12 margin-top-30 text-center">
          <img
            src={'img-tipos/' + p.code + '_' + sex + 'small.svg'}
            className="margin-bot--60 img-80"
          />
          <div className="padding-caja b-caja">
            <hr />
            <h5 className="title">{p.name}</h5>
            <h4>{p.code}</h4>
            <Link
              to={'bars/' + p.code + '/descripcion'}
              className="btn btn-black">
              Leer más
            </Link>
          </div>
        </div>
      );
    });
    let personalidad_green = green.map((p) => {
      return (
        <div className="col-md-3 col-xs-12 margin-top-30 text-center">
          <img
            src={'img-tipos/' + p.code + '_' + sex + 'small.svg'}
            className="margin-bot--60 img-80"
          />
          <div className="padding-caja b-caja">
            <hr />
            <h5 className="title">{p.name}</h5>
            <h4>{p.code}</h4>
            <Link
              to={'bars/' + p.code + '/descripcion'}
              className="btn btn-black">
              Leer más
            </Link>
          </div>
        </div>
      );
    });
    let personalidad_pink = pink.map((p) => {
      return (
        <div className="col-md-3 col-xs-12 margin-top-30 text-center">
          <img
            src={'img-tipos/' + p.code + '_' + sex + 'small.svg'}
            className="margin-bot--60 img-80"
          />
          <div className="padding-caja b-caja">
            <hr />
            <h5 className="title">{p.name}</h5>
            <h4>{p.code}</h4>
            <Link
              to={'bars/' + p.code + '/descripcion'}
              className="btn btn-black">
              Leer más
            </Link>
          </div>
        </div>
      );
    });

    return (
      <div className="container">
        <div className="margin-top-30">
          <h1 className="margin-right-20 title mediatitle">
            TIPOS DE PERSONALIDADES
          </h1>
          {/* <button type="button" className="btn btn-black offset-xs-2">Seleccione genero</button> */}
        </div>
        <div className="row mb-5">
          {personalidad_blue}
          {personalidad_yellow}
          {personalidad_green}
          {personalidad_pink}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Personalities.jsx